import { useQuery } from '@hooks/reactQuery';

import { map } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { findBySiteID } from '@api/manageSite';

import { extractQueryParams } from '@utils/common';

import { TSitesBySearch } from '@interfaces/cells/siteProfile';

import { EDataType } from '@enums/map';

import { refetchOptions } from '@constants/common';
import { SITES_BY_SITE_IDS } from '@constants/queryKeys';

interface IUseQueryFindBySiteIdReturnType {
	sitesBySearch?: Array<TSitesBySearch>;
	isLoading: boolean;
}

export const useQueryFindBySiteId = (searchValue: string): IUseQueryFindBySiteIdReturnType => {
	const { markerType } = useAppSelector(map);

	const { data: sitesBySearch, isInitialLoading } = useQuery({
		queryKey: [SITES_BY_SITE_IDS, searchValue],
		queryFn: extractQueryParams(findBySiteID),
		enabled: [searchValue, markerType === EDataType.sites],
		...refetchOptions,
	});

	return {
		sitesBySearch: sitesBySearch?.items || [],
		isLoading: isInitialLoading,
	};
};
